module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "order-md2": "",
      "order-mt6": "",
      "order-xs2": ""
    }
  }, [_c('chart-view')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-3 ml-0",
    attrs: {
      "xs2": "",
      "order-md1": "",
      "order-xs3": ""
    }
  }, [_c('AdminSideBarMenu')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd58e1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/GareportView.vue
// module id = 1679
// module chunks = 1